import api from './api';

export const chatAPI = {
  getConfig: () => api.get('/chat/config'),
  listUsers: () => api.get('/chat/users'),
  history: (withUserId, params = {}) => api.get('/chat/messages', { params: { with: withUserId, ...params } }),
  send: (to_user_id, body) => api.post('/chat/messages', { to_user_id, body }),
  markRead: (from_user_id) => api.post('/chat/messages/read', { from_user_id }),
  unreadCount: () => api.get('/chat/unread-count'),
  updatePresence: (status) => api.put('/chat/presence', { status }),
};

/** Constrói a URL do WebSocket a partir do REACT_APP_BACKEND_URL. */
export function buildChatWsUrl(token) {
  const base = process.env.REACT_APP_BACKEND_URL || '';
  const wsBase = base.replace(/^http/, 'ws');
  const sep = wsBase.includes('?') ? '&' : '?';
  return `${wsBase}/api/chat/ws${sep}token=${encodeURIComponent(token)}`;
}
